import * as S from './styles'

export interface CountdownCardProps {
  remainingTime?: string,
  formattedDate?: string
}

const CountdownCard = ({ remainingTime, formattedDate }: CountdownCardProps) => {
  return (
    <S.Container className="_py-3 _pr-4 _pl-8 _bg-white" data-test="countdown-card">
      <S.SignalIcon prefix="far" iconName="signal-stream"/>
      <S.RemainingTime className="_d-block _font-weight-bold">{remainingTime}</S.RemainingTime>
      <S.FormattedDate className="_d-block">{formattedDate}</S.FormattedDate>
    </S.Container>
  )
}

export default CountdownCard
